<template>
    <div>
        <!-- <shop-head currentPageName="AGREEMENT"></shop-head> -->
        <div class="container">
            <div class="img_box">
                <img src="../../assets//images/promotional_1.png" alt="">
                <img src="../../assets//images/promotional_2.jpg" alt="">
            </div>
        </div>
        <!-- <common-footer></common-footer> -->
    </div>
</template>

<script>
// import shopHead from '../../components/shop/head'
// import commonFooter from '../../components/common/footer'
export default {
    components: {
        // shopHead,
        // commonFooter
    },
    data() {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0 auto;

    .img_box {
        width: 714px;
        margin: 0 auto;

        img {
            width: 100%;
        }
    }
}
</style>